module.exports = __webpack_public_path__ + "img/BGFeatureMediaLayeredDark.e21a30a7.jpg";